module.exports = __webpack_public_path__ + "src/img/fabu.677eb6b8.svg";